// src/utils/formatters.js

export const formatCurrency = (amount, currency = 'TRY') => {
  if (amount === null || amount === undefined) return '0,00';
  
  const formatter = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  
  const symbol = currency === 'USD' ? '$' : '₺';
  
  return `${formatter.format(amount)} ${symbol}`;
};

export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('tr-TR');
};

export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString('tr-TR');
};